import { request } from '@sweetspot/shared/data-access/api-platform'
import { getApiPlatformBaseUrl } from '@sweetspot/shared/util/functions'

export const getTimeZones = () => {
  const url = `${getApiPlatformBaseUrl()}/courses/timezones`
  return request(url, {
    method: 'GET',
  })
}
